import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Hub from "@/Hub";
import Playbook from "@/Playbook";
import Ernesto from "@/Ernesto";
import Programas from "@/Programas";
import Toolkit from "@/Toolkit";
import Circle from "@/Circle";
import Certificacion from "@/Certificacion";
import { Success, Cancel } from "@/CheckoutPages";
import Admin from "@/Admin";
import Portfolio from "@/Portfolio";
import Intangibles from "@/Intangibles";
import Privacidad from "@/Privacidad";
import Terminos from "@/Terminos";
import Network, { NetworkAuth } from "@/Network";
import ChatWidget from "@/ChatWidget";
import UpsellFunnelHost from "@/components/UpsellFunnel";

const HIDE_CHAT_ON = ["/admin", "/network"];
function ChatGate() {
  const { pathname } = useLocation();
  if (HIDE_CHAT_ON.some((p) => pathname.startsWith(p))) return null;
  return <ChatWidget />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Hub />} />
        <Route path="/playbook" element={<Playbook />} />
        <Route path="/ernesto" element={<Ernesto />} />
        <Route path="/teardown" element={<Navigate to="/#biblioteca" replace />} />
        <Route path="/programas" element={<Programas />} />
        <Route path="/toolkit" element={<Toolkit />} />
        <Route path="/circle" element={<Circle />} />
        <Route path="/certificacion" element={<Certificacion />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/intangibles" element={<Intangibles />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/network" element={<Network />} />
        <Route path="/network/auth" element={<NetworkAuth />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/payment/success" element={<Success />} />
        <Route path="/payment/cancel" element={<Cancel />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <ChatGate />
      <UpsellFunnelHost />
    </BrowserRouter>
  );
}

export default App;
